export class UserPreference {
    tableName:string = "";
    attributeName:string = "";
    attributeValue:string = "";
}